import classes from "./ActivityEditor.module.css";
import {Separator} from "@base-ui/react/separator";
import YuJaButton from "../../components/standardization/YuJaButton";
import {
    ACTIVITY_EDITOR_VIEW,
    GRADE_SCHEMA,
    INTEGRATION_TYPES,
    QUESTION_MAX_POINTS,
    QUESTION_TYPES,
    USER_SETTINGS,
} from "../../utils/constants";
import {useLocalStorageNew} from "../../hooks/useLocalStorageNew";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import React, {Fragment, useLayoutEffect, useRef, useState} from "react";
import {useTranslation, Trans } from "react-i18next";
import {YuJaTooltip} from "../../components/standardization/YuJaTooltip";
import {ReactComponent as Step1} from "./images/workflow_step_1.svg";
import {ReactComponent as Step2} from "./images/workflow_step_2.svg";
import {ReactComponent as Step3} from "./images/workflow_step_3.svg";
import {ReactComponent as COMPLETED} from "./images/workflow_step_completed.svg";
import {ReactComponent as CANVAS_IMG} from "./images/workflow_canvas_img.svg";
import {ReactComponent as BLACKBOARD_IMG} from "./images/workflow_blackboard_img.svg";
import {ReactComponent as D2L_IMG} from "./images/workflow_d2l_img.svg";
import {ReactComponent as MOODLE_IMG} from "./images/workflow_moodle_img.svg";
import {ReactComponent as CSV_IMG} from "./images/workflow_csv_img.svg";
import {ReactComponent as QUE_BANK_IMG} from "./images/workflow_question_bank_img.svg";
import {ReactComponent as CLOSE_ICON} from "./images/close_icon.svg";
import {ReactComponent as GRADE_BOOK_ICON} from "../../images/links/active_gradebook_icon.svg";
import {ReactComponent as IMPORTING_CSV} from "./images/importing_csv_workflow_img.svg";
import {ReactComponent as IMPORTING_QUESTION_BANK} from "./images/importing_question_bank_workflow_img.svg";
import {ReactComponent as IMPORTING_CANVAS} from "./images/importing_canvas_workflow_img.svg";
import {ReactComponent as IMPORTING_BLACKBOARD} from "./images/importing_blackboard_workflow_img.svg";
import {ReactComponent as IMPORTING_D2L} from "./images/importing_d2l_workflow_img.svg";
import {ReactComponent as IMPORTING_MOODLE} from "./images/importing_moodle_workflow_img.svg";
import rightArrowJson from "./animations/Right-Arrows.json";


import {Button} from "@base-ui/react/button";
import {useSynLMSConfiguration} from "../../hooks/useSynLMSConfiguration";
import ImportQuestionsCSV from "./ImportQuestionsCSV";
import {
    getQuestionParticipationPoints,
    getQuestionWeightage,
    notifySuccess
} from "../../utils/helpers";
import ImportQuestionsQuestionBank from "./ImportQuestionsQuestionBank";
import YuJaDialog from "../../components/standardization/YuJaDialog";
import ImportQuestionsCanvas from "./ImportQuestionsCanvas";
import Lottie from "react-lottie";
import ImportQuestionsBlackboard from "./ImportQuestionsBlackboard";
import ImportQuestionsD2L from "./ImportQuestionsD2L";
import ImportQuestionsMoodle from "./ImportQuestionsMoodle";

export const WORKFLOW_OBJ = {
    CANVAS_WORKFLOW: {
        key: "CANVAS_WORKFLOW",
        titleKey: "questionBuilder.importFromCanvas",
        descriptionKey: "questionBuilder.importFromCanvasDesc",
        img: CANVAS_IMG,
        steps: [
            {key: "SELECT_METHOD", labelKey: "questionBuilder.importStepMethod", active: false, completed: false, icon: Step1, isFirst: true, isLast: false},
            {key: "SELECT_COURSE_QUIZ", labelKey: "questionBuilder.importStepCourseQuiz", active: false, completed: false, icon: Step2, isFirst: false, isLast: false},
            {key: "SELECT_QUESTIONS", labelKey: "questionBuilder.importStepQuestions", active: false, completed: false, icon: Step3, isFirst: false, isLast: true},
        ]
    },
    BLACKBOARD_WORKFLOW: {
        key: "BLACKBOARD_WORKFLOW",
        titleKey: "questionBuilder.importFromBlackboard",
        descriptionKey: "questionBuilder.importFromBlackboardDesc",
        img: BLACKBOARD_IMG,
        steps: [
            {key: "SELECT_METHOD", labelKey: "questionBuilder.importStepMethod", active: false, completed: false, icon: Step1, isFirst: true, isLast: false},
            {key: "SELECT_COURSE_TEST", labelKey: "questionBuilder.importStepCourseTest", active: false, completed: false, icon: Step2, isFirst: false, isLast: false},
            {key: "SELECT_QUESTIONS", labelKey: "questionBuilder.importStepQuestions", active: false, completed: false, icon: Step3, isFirst: false, isLast: true},
        ]
    },
    D2L_WORKFLOW: {
        key: "D2L_WORKFLOW",
        titleKey: "questionBuilder.importFromD2l",
        descriptionKey: "questionBuilder.importFromD2lDesc",
        img: D2L_IMG,
        steps: [
            {key: "SELECT_METHOD", labelKey: "questionBuilder.importStepMethod", active: false, completed: false, icon: Step1, isFirst: true, isLast: false},
            {key: "SELECT_COURSE_QUIZ", labelKey: "questionBuilder.importStepCourseQuiz", active: false, completed: false, icon: Step2, isFirst: false, isLast: false},
            {key: "SELECT_QUESTIONS", labelKey: "questionBuilder.importStepQuestions", active: false, completed: false, icon: Step3, isFirst: false, isLast: true},
        ]
    },
    MOODLE_WORKFLOW: {
        key: "MOODLE_WORKFLOW",
        titleKey: "questionBuilder.importFromMoodle",
        descriptionKey: "questionBuilder.importFromMoodleDesc",
        img: MOODLE_IMG,
        steps: [
            {key: "SELECT_METHOD", labelKey: "questionBuilder.importStepMethod", active: false, completed: false, icon: Step1, isFirst: true, isLast: false},
            {key: "SELECT_COURSE_QUIZ", labelKey: "questionBuilder.importStepCourseQuiz", active: false, completed: false, icon: Step2, isFirst: false, isLast: false},
            {key: "SELECT_QUESTIONS", labelKey: "questionBuilder.importStepQuestions", active: false, completed: false, icon: Step3, isFirst: false, isLast: true},
        ]
    },
    CSV_WORKFLOW: {
        key: "CSV_WORKFLOW",
        titleKey: "questionBuilder.importFromCsv",
        descriptionKey: "questionBuilder.importFromCsvDesc",
        img: CSV_IMG,
        steps: [
            {key: "SELECT_METHOD", labelKey: "questionBuilder.importStepMethod", active: false, completed: false, icon: Step1, isFirst: true, isLast: false},
            {key: "UPLOAD_IMPORT_CSV", labelKey: "questionBuilder.importStepUploadCsv", active: false, completed: false, icon: Step2, isFirst: false, isLast: true},
        ]
    },
    QUESTION_BANK_WORKFLOW: {
        key: "QUESTION_BANK_WORKFLOW",
        titleKey: "questionBuilder.importFromQuestionBank",
        descriptionKey: "questionBuilder.importFromQuestionBankDesc",
        img: QUE_BANK_IMG,
        steps: [
            {key: "SELECT_METHOD", labelKey: "questionBuilder.importStepMethod", active: false, completed: false, icon: Step1, isFirst: true, isLast: false},
            {key: "SELECT_QUESTION_BANK", labelKey: "questionBuilder.importStepQuestionBank", active: false, completed: false, icon: Step2, isFirst: false, isLast: false},
            {key: "SELECT_QUESTIONS", labelKey: "questionBuilder.importStepQuestions", active: false, completed: false, icon: Step3, isFirst: false, isLast: true},
        ]
    },

}

export default function ActivityEditorImportQuestions({
                                                          setEditorView,
                                                          draftActivity,
                                                          setDraftActivity,
                                                          courseList=[],
                                                          questionBankId,
                                                          userSettings={},
                                                      }) {
    const {t} = useTranslation();
    const {width: windowWidth} = useWindowDimensions();
    const [setPreviousView, getPreviousView] = useLocalStorageNew("previous_editor_view", "");
    const {getIntegrationType} = useSynLMSConfiguration();
    const [importedQuestions, setImportedQuestions] = useState([]);
    const [isImporting, setIsImporting] = useState(false);
    const [isSelectedImportItem, setIsSelectedImportItem] = useState(false);
    const [removePointsConfirmationShown, setRemovePointsConfirmationShown] = useState(false);

    const LottieOptions = {
        loop: true,
        autoplay: true,
        animationData: rightArrowJson,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
        }
    };

    const integrationType = getIntegrationType();

    const copyWorkflows = (workflows) => {
        const copy = [];
        for (const workflow of workflows) {
            const raw = WORKFLOW_OBJ[workflow.key];
            let copyWorkflow = JSON.parse(JSON.stringify(workflow));
            copyWorkflow.img = raw.img;
            for (let i = 0; i < copyWorkflow.steps.length; i++) {
                let step = copyWorkflow.steps[i];
                let rawStep = raw.steps[i];
                step.icon = rawStep.icon;
            }
            copy.push(copyWorkflow);
        }

        return copy;
    }

    const [workflows, setWorkflows] = useState(() => {
        let res = [];
        if (integrationType === INTEGRATION_TYPES.CANVAS) {//it's Canvas LTI
            res.push(WORKFLOW_OBJ.CANVAS_WORKFLOW);
        } else if (integrationType === INTEGRATION_TYPES.BLACKBOARD) {
            res.push(WORKFLOW_OBJ.BLACKBOARD_WORKFLOW);
        } else if (integrationType === INTEGRATION_TYPES.D2L) {
            res.push(WORKFLOW_OBJ.D2L_WORKFLOW);
        } else if (integrationType === INTEGRATION_TYPES.MOODLE) {
            res.push(WORKFLOW_OBJ.MOODLE_WORKFLOW);
        }
        res.push(WORKFLOW_OBJ.CSV_WORKFLOW);
        res.push(WORKFLOW_OBJ.QUESTION_BANK_WORKFLOW);

        res = copyWorkflows(res)


        res[0].steps[0].active = true;
        return res;
    });

    const [selectedWorkflow, setSelectedWorkflow] = useState(workflows[0]);

    let containerRef = useRef();


    useLayoutEffect(() => {
        if (!!containerRef.current) {
            containerRef.current.focus();
        }
    }, []);

    const onClose = () => {
        let previousView = getPreviousView();
        setPreviousView("");
        setEditorView(!previousView ? ACTIVITY_EDITOR_VIEW.QUESTION_EDITING : previousView);
    }

    const onSelectImportMethod = (workflowKey) => {
        let selected = {};
        for (const workflow of workflows) {
            for (let step of workflow.steps) {
                step.active = false;
                step.completed = false;
            }

            if (workflow.key === workflowKey) {
                workflow.steps[0].active = true;
                selected = workflow;
            }
        }

        setSelectedWorkflow(selected);
    }

    const onBack = () => {
        let key = selectedWorkflow.key;
        let copy = copyWorkflows(workflows);
        let copySelected = copy.find(w => w.key === key);
        let selectedIdx = 0;
        for (let i = 0; i < copySelected.steps.length; i++) {
            let step = copySelected.steps[i];
            if (step.active) {
                selectedIdx = i;
                step.active = false;
                step.completed = false;
            }
        }
        let backStep = copySelected.steps[selectedIdx - 1];
        backStep.active = true;
        backStep.completed = false;

        if (backStep.isFirst) {//clean the flag
            setIsSelectedImportItem(false);
        }


        setWorkflows(copy);
        setSelectedWorkflow(copySelected);
    }

    const isNextDisabled = () => {
        let activeStep = selectedWorkflow.steps.find(s => !!s.active);
        if (activeStep.isLast) {//last step: import question
            return importedQuestions.length === 0;
        } else if (activeStep.isFirst) {//first step
            return false;
        } else {//mid step
            return !isSelectedImportItem;
        }
    }


    const onImport = () => {
        let activityCopy = JSON.parse(JSON.stringify(draftActivity));
        let questionsCopy = activityCopy.questions;
        const size = questionsCopy.length;
        const lastQ = size ? questionsCopy[size - 1] : {};
        if (!lastQ.questionType && !!importedQuestions.length) {
            questionsCopy.pop();
        }
        let curr_questions = questionsCopy;
        importedQuestions.forEach((item) => {
            item.serialNo = curr_questions.length + 1;
            if (draftActivity.gradeSchema === GRADE_SCHEMA.UNGRADED.key) {
                item.weightage = 0;
                item.participationWeightage = 0;
            }
            if (item.questionType === QUESTION_TYPES.WC.name && !item.entries) {
                item.entries = userSettings[USER_SETTINGS.QUESTION_ENTRIES];
            }
            let participationPoints = getQuestionParticipationPoints(item);
            item.weightage = Math.min(QUESTION_MAX_POINTS - participationPoints, item.weightage);
            item.timeLimit = userSettings[USER_SETTINGS.QUESTION_DURATION];
            item.getReadyTimeLimit = userSettings[USER_SETTINGS.QUESTION_COUNTDOWN];
            item.classResultDuration = userSettings[USER_SETTINGS.QUESTION_CLASS_RESULT_DURATION];

            curr_questions.push(item);
        });
        activityCopy.questions = curr_questions;
        setDraftActivity(activityCopy);
        setIsImporting(true);
        setTimeout(() => {
            notifySuccess(t("questionBank.importQuestionsSuccess"));
            onClose();
            setIsImporting(false);
        }, 2000);


    }

    const onNext = () => {
        let key = selectedWorkflow.key;
        let copy = copyWorkflows(workflows);
        let copySelected = copy.find(w => w.key === key);
        let activeStep = copySelected.steps.find(s => !!s.active);

        if (activeStep.isLast) {
            let totalPoints = importedQuestions.reduce(function (result, q) {
                return result + getQuestionWeightage(q);
            }, 0);

            if (draftActivity.gradeSchema === GRADE_SCHEMA.UNGRADED.key && totalPoints > 0) {
                setRemovePointsConfirmationShown(true);
            } else {
                onImport();
            }
        } else {
            let selectedIdx = 0;
            for (let i = 0; i < copySelected.steps.length; i++) {
                let step = copySelected.steps[i];
                if (step.active) {
                    selectedIdx = i;
                    step.active = false;
                    step.completed = true;
                }
            }

            copySelected.steps[selectedIdx + 1].active = true;
            setWorkflows(copy);
            setSelectedWorkflow(copySelected);
        }

        // setIsImporting(true);

    }

    const renderWorkFlow = () => {
        return (
            <div className={classes.workflowContainer} style={{gap: 15}}>
                {selectedWorkflow.steps.map((step, index) => {
                    let ICON = step.icon;
                    if (step.completed) {
                        ICON = COMPLETED;
                    }

                    let isLabelHidden;

                    if (windowWidth < 700) {
                        isLabelHidden = true;
                    } else if (windowWidth > 900 || step.active) {
                        isLabelHidden = false;
                    } else {
                        isLabelHidden = true;
                    }

                    return (
                        <Fragment key={index}>
                            {index !== 0 &&
                                <div className={classes.workflowConnector}/>
                            }
                            <div
                                className={`${classes.workflowLabel} ${step.active ? classes.active : ""} ${step.completed ? classes.completed : ""}`}
                            >
                                <YuJaTooltip disabled={!isLabelHidden} text={t(step.labelKey)} disableTab={true}>
                                   <ICON/>
                                </YuJaTooltip>
                                {!isLabelHidden && <div>{t(step.labelKey)}</div>}
                            </div>
                        </Fragment>
                    );
                })}
            </div>
        );
    }

    const renderChooseImportMethod = () => {
        return (
            <div className={classes.importQuestionBody}>
                <div style={{height: 45, flexShrink: 1}}/>
                <div style={{alignSelf: "center", display: "flex", gap: 15, alignItems: "center"}}>
                    <div className={classes.plusIconWrapper}><GRADE_BOOK_ICON/></div>
                    <h2 className={classes.title}>{t("questionBuilder.importMethodQuestion")}</h2>
                </div>
                <div style={{height: 35, minHeight: 15, flexShrink: 1}}/>
                <div className={classes.row} style={{gap: 15, flexDirection: windowWidth > 900 ? undefined : 'column'}}>
                    {workflows.map((item, index) => {
                        let IMG = item.img;
                        return (
                            <Button
                                key={index}
                                className={`
                                    ${classes.gradeSchemaCard} 
                                    ${selectedWorkflow.key === item.key ? classes.active : ""}
                                `}
                                style={{minWidth: 250, maxWidth: 400, width: '100%'}}
                                onClick={() => onSelectImportMethod(item.key)}
                            >
                                <IMG style={{marginBottom: 15, flexShrink: 0}}/>
                                <span className={classes.title} style={{whiteSpace: "nowrap"}}>{t(item.titleKey)}</span>
                                <span className={classes.description} style={{textAlign: "center"}}>
                                    {t(item.descriptionKey)}
                                </span>

                            </Button>
                        );
                    })}

                </div>
                <div style={{flex: 1, minHeight: 20}}/>
            </div>
        );
    }

    useLayoutEffect(() => {
        // import_question_close_icon
        if (document.activeElement === null || document.activeElement.tagName === "BODY") {
            let closeBtn = document.getElementById("import_question_close_icon");
            if (closeBtn) {
                closeBtn.focus();
            }
        }
    }, [selectedWorkflow]);


    if (isImporting) {
        return (
            <div
                className={`${classes.parentContainer} ${classes.column}`}
                style={{padding: 20}}
            >
                <div className={classes.importQuestionCard} style={{alignItems: "center"}}>
                    <div style={{flex: 1}}/>
                    <div style={{position: "relative", flexShrink: 0}}>
                        {selectedWorkflow.key === WORKFLOW_OBJ.CANVAS_WORKFLOW.key &&
                            <IMPORTING_CANVAS/>
                        }

                        {selectedWorkflow.key === WORKFLOW_OBJ.BLACKBOARD_WORKFLOW.key &&
                            <IMPORTING_BLACKBOARD/>
                        }

                        {selectedWorkflow.key === WORKFLOW_OBJ.D2L_WORKFLOW.key &&
                            <IMPORTING_D2L/>
                        }

                        {selectedWorkflow.key === WORKFLOW_OBJ.MOODLE_WORKFLOW.key &&
                            <IMPORTING_MOODLE/>
                        }

                        {selectedWorkflow.key === WORKFLOW_OBJ.CSV_WORKFLOW.key &&
                            <IMPORTING_CSV/>
                        }

                        {selectedWorkflow.key === WORKFLOW_OBJ.QUESTION_BANK_WORKFLOW.key &&
                            <IMPORTING_QUESTION_BANK/>
                        }
                        <Lottie
                            options={LottieOptions}
                            style={{
                                position: "absolute", top: 160, left: 260,
                                width: 50, height: 50,
                                overflow: 'unset',
                                cursor: "default", margin: 0, alignSelf: "center"
                            }}
                            isClickToPauseDisabled={true}
                        />
                    </div>




                    <h3 className={classes.importingTitle}>
                        {t("questionBuilder.importingQuestions")}
                    </h3>

                    <div className={classes.importingDescription}>
                        {t("questionBuilder.importingQuestionsDesc")}
                    </div>
                    <div style={{flex: 3}}/>
                </div>
            </div>
        );
    }



    return (
        <div className={`${classes.parentContainer} ${classes.column}`} style={{padding: 20}}>
            <div className={classes.importQuestionCard}>
                <div className={classes.importQuestionHeader}>
                    <YuJaTooltip text={t("poll.closeLabel")}>
                        <YuJaButton
                            id={"import_question_close_icon"}
                            ref={containerRef}
                            style={{position: "absolute", top: 15, right: 15}}
                            iconOnly={true}
                            onClick={onClose}
                        >
                            <CLOSE_ICON/>
                        </YuJaButton>
                    </YuJaTooltip>
                    {renderWorkFlow()}
                </div>

                {selectedWorkflow.steps.find(s => !!s.active).isFirst &&
                    renderChooseImportMethod()
                }
                {!selectedWorkflow.steps.find(s => !!s.active).isFirst
                    && selectedWorkflow.key === WORKFLOW_OBJ.CSV_WORKFLOW.key
                    &&
                    <div className={classes.importQuestionBody}>
                        <ImportQuestionsCSV
                            draftActivity={draftActivity}
                            userSettings={userSettings}
                            gradeSchema={draftActivity.gradeSchema}
                            setImportedQuestions={setImportedQuestions}
                        />

                    </div>
                }

                {!selectedWorkflow.steps.find(s => !!s.active).isFirst
                    && selectedWorkflow.key === WORKFLOW_OBJ.QUESTION_BANK_WORKFLOW.key
                    &&
                    <div className={classes.importQuestionBody}>
                        <ImportQuestionsQuestionBank
                            draftActivity={draftActivity}
                            userSettings={userSettings}
                            importedQuestions={importedQuestions}
                            setImportedQuestions={setImportedQuestions}
                            selectedWorkflow={selectedWorkflow}
                            setIsSelectedImportItem={setIsSelectedImportItem}
                        />
                    </div>
                }

                {!selectedWorkflow.steps.find(s => !!s.active).isFirst
                    && selectedWorkflow.key === WORKFLOW_OBJ.CANVAS_WORKFLOW.key
                    &&
                    <div className={classes.importQuestionBody}>
                        <ImportQuestionsCanvas
                            courseList={courseList}
                            draftActivity={draftActivity}
                            userSettings={userSettings}
                            importedQuestions={importedQuestions}
                            setImportedQuestions={setImportedQuestions}
                            selectedWorkflow={selectedWorkflow}
                            setIsSelectedImportItem={setIsSelectedImportItem}
                        />
                    </div>
                }

                {!selectedWorkflow.steps.find(s => !!s.active).isFirst
                    && selectedWorkflow.key === WORKFLOW_OBJ.BLACKBOARD_WORKFLOW.key
                    &&
                    <div className={classes.importQuestionBody}>
                        <ImportQuestionsBlackboard
                            courseList={courseList}
                            draftActivity={draftActivity}
                            userSettings={userSettings}
                            importedQuestions={importedQuestions}
                            setImportedQuestions={setImportedQuestions}
                            selectedWorkflow={selectedWorkflow}
                            setIsSelectedImportItem={setIsSelectedImportItem}
                        />
                    </div>
                }

                {!selectedWorkflow.steps.find(s => !!s.active).isFirst
                    && selectedWorkflow.key === WORKFLOW_OBJ.D2L_WORKFLOW.key
                    &&
                    <div className={classes.importQuestionBody}>
                        <ImportQuestionsD2L
                            courseList={courseList}
                            draftActivity={draftActivity}
                            userSettings={userSettings}
                            importedQuestions={importedQuestions}
                            setImportedQuestions={setImportedQuestions}
                            selectedWorkflow={selectedWorkflow}
                            setIsSelectedImportItem={setIsSelectedImportItem}
                        />
                    </div>
                }

                {!selectedWorkflow.steps.find(s => !!s.active).isFirst
                    && selectedWorkflow.key === WORKFLOW_OBJ.MOODLE_WORKFLOW.key
                    &&
                    <div className={classes.importQuestionBody}>
                        <ImportQuestionsMoodle
                            courseList={courseList}
                            draftActivity={draftActivity}
                            userSettings={userSettings}
                            importedQuestions={importedQuestions}
                            setImportedQuestions={setImportedQuestions}
                            selectedWorkflow={selectedWorkflow}
                            setIsSelectedImportItem={setIsSelectedImportItem}
                        />
                    </div>
                }


                <Separator orientation={"horizontal"} size={"small"} className={classes.Separator}/>
                <div className={classes.importQuestionCardFooter}>
                    <YuJaButton
                        size={"small"}
                        style={{minWidth: 120}}
                        disabled={selectedWorkflow.steps.find(s => !!s.active).isFirst}
                        onClick={() => onBack()}
                    >
                        {t("common.back")}
                    </YuJaButton>


                    <YuJaButton
                        disabled={isNextDisabled()}
                        isLoading={isImporting}
                        style={{minWidth: 120}}
                        size={"small"}
                        onClick={() => onNext()}
                    >
                        {selectedWorkflow.steps.find(s => !!s.active).isLast ? t("questionBank.importQuestionsText") :  t("common.next")}
                    </YuJaButton>
                </div>
            </div>

            <YuJaDialog
                open={removePointsConfirmationShown}
                setOpen={setRemovePointsConfirmationShown}
                title={t("questionBuilder.importedPointsRemoved")}
                centerAligned={false}
                submitText={t("common.continue")}
                onSubmit={onImport}
                closeText={t("common.cancel")}
            >
                <div style={{color: "#6B6B6B", marginBottom: 10, whiteSpace: "pre-line"}}>
                    <Trans
                        i18nKey="questionBuilder.ungradedPointsRemovedDesc"
                        values={{type: t("poll.ungradedText")}}
                        components={{bold: <strong/>}}
                    />
                </div>

                <div style={{color: "#6B6B6B", margin: 0, whiteSpace: "pre-line"}}>
                    {t("questionBuilder.continueImporting")}
                </div>
            </YuJaDialog>
        </div>
    );
}


